exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "news12-ad button{padding:.3vh;background-color:transparent;border:0;height:inherit}news12-ad button.selected,news12-ad button:focus,news12-ad button:hover{outline:none;border:.3vh solid #ffac25;padding:0}news12-ad img{display:inline-block;vertical-align:middle;width:100%;height:100%;object-fit:cover;overflow:hidden}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./client/app/components/common/news12Ad/news12Ad.scss
 ** module id = 222
 ** module chunks = 0
 **/